import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { initFlowbite } from 'flowbite';

@Component({
  selector: 'app-side-bar',
  standalone: true,
  imports: [CommonModule,RouterModule],
  templateUrl: './side-bar.component.html',
  styleUrl: './side-bar.component.css'
})
export class SideBarComponent implements OnInit {
  protected isSidebarOpen = false;
  protected showManagementSubMenu: boolean = false;
  activeRoute: string = '';
  protected appManagementRoutes = ['/app-announcement', '/app-message', '/app-management', '/app-notification']; // Add more routes if needed

  
  constructor(
    private router: Router,
  ) {}


  ngOnInit(): void {
    initFlowbite();

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.activeRoute = event.urlAfterRedirects;

        // If route contains 'app-announcement', open App Management menu
        this.showManagementSubMenu = this.appManagementRoutes.some(route => this.activeRoute.includes(route));
      }
    });

  }
   // Method to toggle the sidebar
   toggleSidebar(): void {
    this.isSidebarOpen = !this.isSidebarOpen;
  }

  closeSidebar(): void {
    this.isSidebarOpen = false;
  }


  /**
   * Toggles the visibility of the management submenu.
   * Changes the state of `showManagementSubMenu` from true to false or vice versa.
   */
  toggleManagementSubMenu(): void {
    this.showManagementSubMenu = !this.showManagementSubMenu;
  }
}
